module.exports = __webpack_public_path__ + "img/c08_unittechbowmanchampion_Normal_ua.adc0d958.webp";